module.exports = __webpack_public_path__ + "img/tracking_setting.89e19a83.svg";